var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGreenShield = function SvgGreenShield(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10.691 1.387-7.5 2.728v6.063c0 6.85 7.278 8.713 7.352 8.732l.148.036.15-.036c.073-.018 7.35-1.882 7.35-8.732V4.115l-7.5-2.728Zm-1.25 12.174L6.5 10.62l.883-.883 2.058 2.058L14 7.236l.884.883-5.442 5.442Z",
    fill: "#249241"
  })));
};
export default SvgGreenShield;